import { useContext, useState, useEffect } from "react";
import { EnvoieContext } from "../../context/envoieContext/EnvoieContext";
import { useNavigate, useParams } from "react-router-dom";
import { getHistories } from "../../context/envoieContext/apiCalls";
import ErrorComponent from "../../components/errorComponent/ErrorComponent";
import FilterIdInput from "../../components/filterIdInput/FilterIdInput";
import LoadingComponent from "../../components/loadingComponent/LoadingComponent";
import PageSizeComponent from "../../components/pageSizeComponent/PageSizeComponent";
import AdminSideBar from "../../components/adminSideBar/AdminSideBar";
import CartBox from "../../components/cartBox/CartBox";
import TinyPaginationComponent from "../../components/paginationComponent/TinyPaginationComponent";

function Envoie() {
  const { dispatch, envois, isFetching, error, count: pages } = useContext(EnvoieContext);
  const { page = 1 } = useParams();
  const navigate = useNavigate();
  const [pageSize, setPageSize] = useState(20);

  const [id, setId] = useState("");

  useEffect(() => {
    getHistories(dispatch, pageSize, page, id);
  }, [dispatch, pageSize, page, id])

  useEffect(() => {
    navigate(`/envois/1`);
  }, [id])

  return (
    <div className='container-global'>
      <AdminSideBar activeTab="envoie" />
      <div className='center'>
        <div className="title">
          <span className="material-symbols-rounded">shoppingmode</span>
          <span>Envois :</span>
        </div>

        {
          error ? <ErrorComponent error={error} /> : (
            <>
              <div className="filter" style={{ maxWidth: '360px' }}>
                <span className="adv-research">Recherche Avancée</span>
                <div className="filter-content">
                  <FilterIdInput placeholder={'Tracking'} setItem={setId} />
                </div>
              </div>

              {
                isFetching ? <LoadingComponent /> : (
                  envois.length === 0 ? <span className='no-data'>Il n'y a pas encore de données</span>
                    : (
                      <>
                        <PageSizeComponent pageSize={pageSize} setPageSize={setPageSize} itemLocation='envois' />
                        <div className="content">
                          {
                            <>
                            {
                              envois.map((history, index) => (
                                <CartBox  key={index} idHistory={history.id} history={history} page={page} dispatch={dispatch} />
                              ))
                            }
                              {
                                (pages > 1) && (<TinyPaginationComponent page={page} itemContext={EnvoieContext} item='envois' />)
                              }
                            </>
                          }
                        </div>
                      </>
                    )
                )
              }
            </>
          )
        }

      </div>
    </div>
  )
}
export default Envoie